import axios from 'axios';
import boxArena from './box-arena';
import asideSummary from '../aside-summary';
import cryptDecrypt from '../../../../core/crypt-decrypt';

declare let booking_object: any;

const modBoxArena = new boxArena();

const modAsideSummary = new asideSummary();

const modCryptDecrypt = new cryptDecrypt("25a02a871c482b08a36db790703c455c03e8e38d37d9615ba4b98be07f7a6842");

// Define the structure of the decrypted booking data
interface BookingData {
    order_uuid: string;
    room_id: number;
    arena_id: number;
    type_arena: string;
    game_id: number;
    date_start: string;
    date_end: string;
    players: number;
    price_paid: string;
    price_left: string;
    price_total: string;
    time: string;
}

export default class detailsBooking{ 

    /**
     * Get details book
     * @returns 
     */
    getDetailsBooking(
        book_calendar: any,
        el_rooms: string,
        el_games: string,
        el_time_slot: string,
        el_players: string
    ) {
        
        const _that = this;
        
        // Element room
        const elRoom = document.querySelector(el_rooms) as HTMLSelectElement | null;
        
        // Element game
        const elGame = document.querySelector(el_games) as HTMLSelectElement | null;

        // Element time slot
        const elTimeSlot = document.querySelector(el_time_slot) as HTMLSelectElement | null;

        // Element players
        const elPlayers = document.querySelector(el_players) as HTMLSelectElement | null;

        // Element time slot
        const val_date = book_calendar.getDate('y/mm/dd');

        // Input shared arena
        const input_shared_arena: HTMLInputElement | null = document.querySelector('#field_type_arena_1');

        // Input full arena
        const input_full_arena: HTMLInputElement | null = document.querySelector('#field_type_arena_2');

        // Aside fields
        const smr_price = document.querySelector('#smr-price') as HTMLSpanElement;
        const smr_price_total = document.querySelector('#smr-price-total') as HTMLSpanElement;

        if(elRoom === null || elGame === null || elTimeSlot === null || elPlayers === null || input_shared_arena === null || input_full_arena === null){

            return;

        }

        if(
            elRoom?.value.length === 0 ||
            elGame?.value.length === 0 ||
            (typeof val_date == 'undefined') ||
            elTimeSlot?.value.length === 0 ||
            elPlayers?.value.length === 0
        )
        {
            
            return;

        }

        // Get stored value
        let order_id = '';

        // Get order ID
        const get_order = _that.getLocalStorage();

        if(get_order){
            
            order_id = get_order.order_uuid;

        }

        // Post data
        const post_data = {
            'room_id': (typeof elRoom !== 'undefined' && elRoom !== null && elRoom?.value !== null) ? elRoom.value : '',
            'game_id': (typeof elGame !== 'undefined' && elGame !== null && elGame?.value !== null) ? elGame.value : '',
            'time_slot': (typeof elTimeSlot !== 'undefined' && elTimeSlot !== null && elTimeSlot?.value !== null) ? elTimeSlot.value : '',
            'players': (typeof elPlayers !== 'undefined' && elPlayers !== null && elPlayers?.value !== null) ? elPlayers.value : '',
            'type_arena': 'shared',
            'date': val_date,
            'order_id': order_id
        };
        
        // Query string
        const queryString = new URLSearchParams(post_data).toString();
        
        // Call ajax
        axios.post(booking_object.rest_urls.get_details_booking, queryString, {
            
            validateStatus: function(status){
                
                return status == 200;
                
            }

        })
        .then(function (response:any){

            const box_arena: HTMLElement | null = document.querySelector('#box-arena');

            // Get arena
            const arena = response.data.data.arena_available;

            // Get full arena
            const arena_full = response.data.data.full_arena;

            // Get players available
            const player_available = response.data.data.player_available;

            // Prices booking
            const prices = response.data.data.prices;

            // Set Box Arena
            modBoxArena.store(
                box_arena,
                arena,
                player_available,
                arena_full,
                prices
            );

            modAsideSummary.getTypeArena();
            modAsideSummary.storePrices(prices);
            modAsideSummary.changeTypeArena(prices);

        }).catch(function (error: any){

            console.log(error);

        });

    }

    /**
     * Get local storage
     * @returns 
     */
    getLocalStorage(){
        
        let output: BookingData | null = null;
        
        const get_order = localStorage.getItem('booking-data-order');

        if(get_order){
            
            const retrievedData = JSON.parse(get_order);

            const decrypted = modCryptDecrypt.decryptObject<{
                order_uuid: string,
                room_id: number,
                arena_id: number,
                type_arena: string,
                game_id: number,
                date_start: string,
                date_end: string,
                players: number,
                price_paid: string,
                price_left: string,
                price_total: string,
                time: string,
            }>(retrievedData.encryptedData, retrievedData.iv);

            output = decrypted;

        }

        return output;

    }

}
